import { lazy, Suspense } from 'react';

const OrgChatPage = lazy(() =>
  import('./OrgChatPage').then((m) => ({ default: m.OrgChatPage })),
);

export function LazyOrgChatPage() {
  return (
    <Suspense
      fallback={
        <div className="flex-1 flex items-center justify-center text-surface-400">
          Loading...
        </div>
      }
    >
      <OrgChatPage />
    </Suspense>
  );
}
